{
  "dataSync": {
    "sync": {
      "title": {
        "loading": "Szinkronizálás",
        "personio": "Szinkronizálás a Personióval",
        "excel": "Szinkronizálás Excellel"
      },
      "steps": {
        "structure": "Struktúra",
        "newPeople": "Új személyek",
        "changes": "Módosítások",
        "leavers": "Kilépők",
        "removals": "Eltávolítások",
        "confirm": "Megerősítés"
      },
      "stepsLabel": "Lépések",
      "kind": {
        "departmentCreate": "Új osztály",
        "departmentMove": "Osztály áthelyezve",
        "teamCreate": "Új csapat",
        "roleCreate": "Új funkció",
        "systemCreate": "Új rendszer",
        "unitRename": {
          "department": "Osztály átnevezve",
          "team": "Csapat átnevezve",
          "role": "Funkció átnevezve",
          "system": "Rendszer átnevezve"
        },
        "unitLead": {
          "department": "Osztályvezető",
          "team": "Csapatvezető",
          "role": "Funkcióvezető",
          "system": "Rendszer tulajdonosa"
        },
        "unitDelete": {
          "department": "Osztály törlése",
          "team": "Csapat törlése",
          "role": "Funkció törlése",
          "system": "Rendszer törlése"
        }
      },
      "labelled": "{{label}}: {{value}}",
      "under": "{{name}} alatt",
      "topLevel": "Legfelső szint",
      "field": {
        "name": "Név",
        "email": "E-mail",
        "department": "Osztály",
        "role": "Pozíció",
        "team": "Csapat",
        "location": "Telephely"
      },
      "skipped": {
        "missingEmail": "E-mail nélkül"
      },
      "unsuppliedPeople_one": "{{count}} személy nem vehető át innen: {{source}}, mert hiányzik az osztálya, a pozíciója vagy az e-mail-címe:",
      "unsuppliedPeople_other": "{{count}} személy nem vehető át innen: {{source}}, mert hiányzik az osztályuk, a pozíciójuk vagy az e-mail-címük:",
      "blockedReason": {
        "missingDepartment": "Nincs osztály",
        "missingRole": "Nincs pozíció",
        "missingOwner": "Nincs rendszertulajdonos",
        "nameTaken": "A név már foglalt",
        "emailNotChangeable": "Ez az e-mail-cím itt nem módosítható",
        "emailTaken": "Az e-mail-cím már foglalt",
        "externalPerson": "Külső személy",
        "actingAdmin": "Az Ön saját fiókja",
        "lastOrgManager": "Utolsó szervezeti menedzser",
        "inUse": "Még használatban van",
        "personioLed": "A Personio kezeli"
      },
      "waitingOn": "Akkor választható ki, ha a hozzá tartozó sorok ki vannak választva ezekben a lépésekben: {{steps}}",
      "leaverReason": {
        "inactive": "inaktív a Personióban",
        "absentPersonio": "már nem szerepel a Personióban",
        "absentExcel": "már nem szerepel a fájlban"
      },
      "holds": {
        "leads": "Vezeti: {{name}}",
        "processesOwned_one": "{{count}} folyamat tulajdonosa",
        "processesOwned_other": "{{count}} folyamat tulajdonosa",
        "processesAccountable_one": "{{count}} folyamatért felelős",
        "processesAccountable_other": "{{count}} folyamatért felelős",
        "systemOwned": "A(z) {{name}} rendszer tulajdonosa",
        "openAssignments_one": "{{count}} nyitott feladat",
        "openAssignments_other": "{{count}} nyitott feladat"
      },
      "usage": {
        "people_one": "{{count}} személy",
        "people_other": "{{count}} személy",
        "subDepartments_one": "{{count}} alosztály",
        "subDepartments_other": "{{count}} alosztály",
        "orgFunctions_one": "{{count}} csapat vagy funkció",
        "orgFunctions_other": "{{count}} csapat vagy funkció",
        "processes_one": "{{count}} folyamat",
        "processes_other": "{{count}} folyamat",
        "processSteps_one": "{{count}} folyamatlépés",
        "processSteps_other": "{{count}} folyamatlépés",
        "suggestions_one": "{{count}} javaslat",
        "suggestions_other": "{{count}} javaslat"
      },
      "confirm": {
        "structure": "Struktúra létrehozása vagy módosítása",
        "createPeople": "Személyek létrehozása",
        "changePeople": "Személyek módosítása",
        "deletePeople": "Személyek törlése",
        "deleteUnits": "Osztályok, csapatok, funkciók és rendszerek törlése",
        "deleteNamedUnits": "Törlés: {{units}}",
        "changeNamedLeads": "{{units}} vezetőjének módosítása",
        "noDownloadList": "Ez a fájl nem az „{{button}}” funkcióval készült. Ezért a Bliks nem javasol sem kilépőket, sem eltávolításokat."
      },
      "unitCount": {
        "department_one": "{{count}} osztály",
        "department_other": "{{count}} osztály",
        "team_one": "{{count}} csapat",
        "team_other": "{{count}} csapat",
        "role_one": "{{count}} funkció",
        "role_other": "{{count}} funkció",
        "system_one": "{{count}} rendszer",
        "system_other": "{{count}} rendszer"
      },
      "apply": "Szinkronizálás alkalmazása",
      "applied": "Szinkronizálás alkalmazva",
      "notApplied": "Nincs alkalmazva",
      "outcome": {
        "failed": "Sikertelen",
        "conflict": "Az érték az ellenőrzés óta megváltozott a Bliksben"
      },
      "retry": "Alkalmazás újra"
    },
    "settings": {
      "title": "Adatszinkronizálás",
      "kind": {
        "excel": "Excel",
        "personio": "Personio"
      },
      "connections": "Kapcsolatok",
      "connected": "Csatlakoztatva",
      "connect": "Csatlakoztatás",
      "uploadExcel": "Excel feltöltése",
      "downloadExcel": "Excel letöltése",
      "startSync": "Szinkronizálás indítása",
      "changeCredentials": "Hozzáférési adatok módosítása",
      "continueSync": "Szinkronizálás folytatása",
      "unlink": "Leválasztás",
      "unlinkConfirm": {
        "title": "Personio leválasztása?",
        "description": "A Bliksben semmi sem törlődik. A Personióból származó személyeket, osztályokat és csapatokat ezután a Bliksben vagy Excellel kezelheti."
      },
      "lastSync": "Utolsó szinkronizálás: {{date}}",
      "noSyncApplied": "Még nem alkalmazott szinkronizálást",
      "invalidRow": "{{sheet}} munkalap, {{row}}. sor: {{errors}}",
      "emptyFile": "A(z) {{sheet}} munkalap nem tartalmaz személyeket.",
      "sheetRows_one": "{{sheet}} munkalap, {{rows}}. sor",
      "sheetRows_other": "{{sheet}} munkalap, sorok: {{rows}}",
      "missingSheets": "A fájlból hiányoznak munkalapok ({{sheets}}). Kérjük, töltse le az aktuális fájlt, és abban rögzítse a módosításait.",
      "missingColumns": "Egyes munkalapokról hiányoznak oszlopok. Kérjük, töltse le az aktuális fájlt, és abban rögzítse a módosításait.",
      "sheetColumns": "{{sheet}} munkalap: {{columns}}"
    },
    "personio": {
      "title": "Personio csatlakoztatása",
      "replaceTitle": "Hozzáférési adatok módosítása",
      "clientId": "Ügyfél-azonosító",
      "clientSecret": "Ügyfél-titok",
      "test": "Kapcsolat tesztelése",
      "testSucceeded": "A kapcsolat működik.",
      "connect": "Csatlakoztatás",
      "instructions": {
        "step1": "A Personióban nyissa meg a <bold>Settings → API credentials</bold> menüpontot, és kattintson a „Create custom integration” gombra (csak API-hozzáférést tartalmazó Personio-csomaggal).",
        "step2": "Kapcsolja be az olvasási hozzáférést az <bold>Employees</bold> elemnél (ezzel olvassa a Bliks a pozícióhoz tartozó foglalkoztatásokat is), és a <bold>Readable employee attributes</bold> listában engedélyezze ezeket: ID, First name, Last name, Email, Status, Department, Team, Position, Supervisor, Workplace. ID, Status, Email, Department és Position nélkül a Bliks senkit sem tud átvenni.",
        "step3": "Kapcsolja be az olvasási hozzáférést az <bold>Org Units</bold> elemnél (osztályok, csapatok és vezetőik).",
        "step3a": "A pozícióhoz kapcsolja be az olvasási hozzáférést a <bold>Job catalog</bold> elemnél.",
        "step4": "A <bold>Custom Reports</bold> maradjon kikapcsolva.",
        "step5": "Írja be ide az Ügyfél-azonosítót és az Ügyfél-titkot, majd kattintson a „Kapcsolat tesztelése” gombra.",
        "readOnlyNote": "A Bliks csak ezeket a mezőket olvassa, és soha nem ír a Personióba.",
        "helpLink": "Personio súgó: API-hozzáférési adatok (angolul)",
        "helpUrl": "https://support.personio.de/hc/en-us/articles/4404623630993-Generate-and-manage-API-credentials"
      }
    }
  }
}
